import {MassiveActionsProcessHeader} from "../components/UtilsComponents";
import * as React from "react";
import {ProcessPage, ProcessStageOrder} from "../../Processes";
import {CodesValidation} from "../components/CodesValidation";
import {MassiveActionProcessState} from "../MassiveActionsProvider";
import {VeboxOverlay} from "../../../components/overlay/VeboxOverlay";
import {DeleteStage} from "../components/DeleteStage";
import {RestDataLoader} from "../../../dashboard/widgets/unilever/RestDataLoader";
import {ValidatedElement, ValidatedElementList} from "../models";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {DeleteWarningModal} from "../components/DeleteWarningModal";


declare var AppTranslations: AppTranslations;

async function validateEquipment(codes: string[]): Promise<ValidatedElementList> {
    return new Promise((resolve, reject)=> {
        RestDataLoader.postJSON(
            "equipment/validation",
            {
                list: codes
            },
            resolve,
            reject,
        );
    });
}


async function deleteEquipment(guids: string[]): Promise<void> {
    return new Promise((resolve, reject) => {
        RestDataLoader.deleteJSON(
            "equipment",
            {
                equipments: guids
            },
            resolve,
            reject,
        );
    })
}

export function EquipmentDeletionProcess() {

    const [list, setList] = React.useState([])


    const overlayController = VeboxOverlay.useTarget(null);

    async function validateAndGet(codes: string[]): Promise<any> {
        const result = await validateEquipment(codes);
        setList(result.validatedElementList);
    }


    async function action(validEquipment: ValidatedElement[]): Promise<void> {
        if(validEquipment.findIndex(({hasTelemetry}) => hasTelemetry) > -1) {
            return new Promise((resolve, reject) => {

                async function confirm() {
                    return deleteEquipment(validEquipment.map(({guid}) => guid))
                        .then(() => {
                            setList([]);
                            overlayController.clear();
                            resolve();
                        })
                        .catch((e) => {
                            setList([]);
                            overlayController.clear();
                            reject(e);
                        });
                }

                function close() {
                    overlayController.clear()
                    resolve();
                }

                overlayController.show(<DeleteWarningModal close={close} confirm={confirm}/>);
            });
        } else {
            try {
                await deleteEquipment(validEquipment.map(({guid}) => guid));
            } catch (e) {
                throw e;
            } finally {
                setList([]);
            }
        }
    }


    return (
        <ProcessPage total={2} className={"flx-col"}>
            <MassiveActionsProcessHeader
                processHeaderTitle={AppTranslations.entityDeleteProcess.equipmentDeleteTitle}
                processIndicatorsTitles={[
                    AppTranslations.massiveActions.packageClaimProcess.packageCodeStageTitle,
                    AppTranslations.genericWords.delete
                ]}
            />
            <VeboxOverlay.Target {...overlayController.targetProps} className={"process-stages flx-row"}>
                <CodesValidation
                    validationFunction={validateAndGet}
                    stepNumber={1}
                    stageOrder={ProcessStageOrder.FIRST}
                    title={AppTranslations.massiveActions.packageClaimProcess.packageCodeStageTitle}
                    cardTitle={AppTranslations.massiveActions.packageClaimProcess.packageCodeStageTitle}
                    errorMessage={"Error"}
                    errorDescription={"Error message"}
                    massiveActionProcessState={MassiveActionProcessState.INITIAL}
                />
                <DeleteStage title={"Equipment"} list={list} action={action}/>
            </VeboxOverlay.Target>
        </ProcessPage>
    );
}